import { useState } from 'react';
import { Field } from 'formik';
import { Box, Flex, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import * as Yup from 'yup';
import { PlusCircle } from '@kula-ai/icons/dual-tone/PlusCircle';
import { TextareaField } from '@/components/formBuilder/formFields/TextareaField';

interface DescriptionFieldProps {
  name: string;
}

const DescriptionField = ({ name }: DescriptionFieldProps) => {
  const [showDescription, setShowDescription] = useState(false);
  return (
    <Field name={name}>
      {({ field }) =>
        !showDescription && !field.value ? (
          <Flex
            alignItems="center"
            gap="6px"
            cursor="pointer"
            aria-label="Add description"
            role="button"
            onClick={() => setShowDescription(true)}
          >
            <Icon color="primary-600" as={PlusCircle} />
            <KText
              size="sm-medium"
              color="primary-600"
              data-test-id="add-description"
            >
              Add description
            </KText>
          </Flex>
        ) : (
          <Box>
            <KText size="sm-medium" mb="8px">
              Description
            </KText>
            <TextareaField
              item={{
                name: name,
                label: 'Description',
                maxLength: 500,
                validation: Yup.string()
                  .trim()
                  .max(500, 'Max 500 characters allowed'),
              }}
              field={field || ''}
              formik={undefined}
            />
          </Box>
        )
      }
    </Field>
  );
};

export default DescriptionField;
